import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MmscanToaster } from '@mmscan/angular-ui/toast';

@Component({
  selector: 'mp-root',
  imports: [RouterOutlet, MmscanToaster],
  templateUrl: './app.html',
})
export class App {}
